const _version = "3.0.2"
function version() {
    return _version
}
export default version
